import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import api from "@/lib/api";

const cache = new Map();
if (typeof document !== "undefined" && !document.getElementById("crm-img-fade-style")) { const st = document.createElement("style"); st.id = "crm-img-fade-style"; st.textContent = "@keyframes crm-img-fade{from{opacity:0}to{opacity:1}}"; document.head.appendChild(st); }

/** Image servie par l'API (Bearer requis) → blob URL mis en cache par fileId (ou par `path` explicite). */
export default function CrmFileImage({ fileId, path, alt = "", className = "", style, placeholder = null, fade = false }) {
  const key = fileId ? (path || `/crm/files/${fileId}/download`) : null;
  const [src, setSrc] = useState(key ? cache.get(key) : null);
  useEffect(() => {
    if (!key) { setSrc(null); return; }
    if (cache.has(key)) { setSrc(cache.get(key)); return; }
    let alive = true;
    api.get(key, { responseType: "blob" }).then((r) => {
      const url = URL.createObjectURL(r.data); cache.set(key, url); if (alive) setSrc(url);
    }).catch(() => alive && setSrc("error"));
    return () => { alive = false; };
  }, [key]);
  if (!fileId || src === "error") return <div className={`flex items-center justify-center text-[#55555a] ${className}`} style={style}><ImageOff size={22} /></div>;
  if (!src) return placeholder || <div className={`animate-pulse bg-white/5 ${className}`} style={style} />;
  return <img src={src} alt={alt} className={className} style={fade ? { ...style, animation: "crm-img-fade .3s ease-out" } : style} />;
}
